jQuery(document).ready(function () {
    let e = 0;
    jQuery("#non-tile-area-list li").length > 0 && (e = jQuery("#non-tile-area-list li").length),
        jQuery(document).on("click", ".sid-steps-list .sid-step-item.visited .sid-step-link", function () {
            t(jQuery(this).parent().index());
        }),
        jQuery(document).on("click", ".remove-non-tile-area-btn", function () {
            let e = jQuery(this).data("index");
            jQuery("#non-tile-area-item-" + e).remove();
        });
    var t = function (e) {
        e >= 0 &&
            jQuery(".sid-steps-list .sid-step-item").length > e &&
            (jQuery(".sid-steps-list").find(".sid-step-item.active").addClass("visited").removeClass("active"),
            jQuery(".sid-steps-list .sid-step-item").eq(e).addClass("active"),
            jQuery(".sid-canvas-steps-list").find(".sid-step-item.active").addClass("visited").removeClass("active"),
            jQuery(".sid-canvas-steps-list li.sid-step-item").eq(e).addClass("active"));
    };
});
